import moment from 'moment';
import React from 'react';

const ChecksTab = props => {
  const getClassName = check => {
    if (check.dateCancelled) return 'red-text';
    if (check.dateCleared) return 'green-text';
    return '';
  };

  return (
    <div style={{ padding: '1vw' }}>
      {props.checks ? (
        <table>
          <thead>
            <tr>
              <th style={{ padding: '0px' }}>Check Number</th>
              <th style={{ padding: '0px' }}>Date Issued</th>
              <th style={{ padding: '0px' }}>Amount</th>
              <th style={{ padding: '0px' }}>Date Cleared</th>
              <th style={{ padding: '0px' }}>Date Cancelled</th>
            </tr>
          </thead>
          <tbody>
            {props.checks?.map(c => (
              <tr key={c.id} className={getClassName(c)}>
                <td style={{ padding: '2px' }}>{c.checkNumber}</td>
                <td style={{ padding: '2px' }}>
                  {moment.utc(c.dateIssued).local().format('MM/DD/YYYY')}
                </td>
                <td style={{ padding: '2px' }}>${c.amount}</td>
                <td style={{ padding: '2px' }}>
                  {c.dateCleared
                    ? moment.utc(c.dateCleared).local().format('MM/DD/YYYY')
                    : ''}
                </td>
                <td style={{ padding: '2px' }}>
                  {c.dateCancelled
                    ? moment.utc(c.dateCancelled).local().format('MM/DD/YYYY')
                    : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </div>
  );
};

export default ChecksTab;
